import { render, staticRenderFns } from "./OpenQuestionInput.vue?vue&type=template&id=fa373b76&scoped=true&"
import script from "./OpenQuestionInput.vue?vue&type=script&lang=js&"
export * from "./OpenQuestionInput.vue?vue&type=script&lang=js&"
import style0 from "./OpenQuestionInput.vue?vue&type=style&index=0&id=fa373b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa373b76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
